import { LandingPageTemplate } from "@/components/layout/LandingPageTemplate";
import { CFOHeroSection } from "@/components/landing/cfos/CFOHeroSection";
import { CFOChallengeSection } from "@/components/landing/cfos/CFOChallengeSection";
import { BenefitSection } from "@/components/landing/BenefitSection";
import { SocialProofSection } from "@/components/landing/cfos/SocialProofSection";
import { CtaSection } from "@/components/landing/CtaSection";

const ManagedITCybersecurityCFOs = () => {
  const edgefiApproachBenefits = [
    {
      title: "Rightsizing Tools",
      description: "Identifying and eliminating redundant licenses and platforms to reduce vendor sprawl"
    },
    {
      title: "Unlocking Microsoft 365",
      description: "Leveraging built-in enterprise-grade security, compliance, and collaboration features"
    },
    {
      title: "Process Optimization",
      description: "Streamlining IT operations to reduce overhead and improve productivity"
    },
    {
      title: "Financial Alignment",
      description: "Turning IT spend into a predictable, strategic investment with clear ROI"
    }
  ];

  const financialBenefits = [
    {
      title: "Lower Total Cost of Ownership",
      description: "Fewer vendors, less bloat, more efficient operations"
    },
    {
      title: "Improved Risk Posture",
      description: "Use proven, enterprise-grade security you already own"
    },
    {
      title: "Stronger Financial Stewardship",
      description: "Confidence you're investing wisely, not redundantly"
    },
    {
      title: "Clear ROI Reporting",
      description: "Data-backed insights for board and leadership discussions"
    }
  ];

  return (
    <LandingPageTemplate
      title="Managed IT & Cybersecurity for CFOs"
      description="Cut IT & cybersecurity costs without compromising security. Stop buying new tools and unlock hidden value in technology you already own."
      keywords={[
        "CFO cybersecurity budget",
        "IT cost reduction",
        "managed cybersecurity ROI",
        "Microsoft 365 security optimization",
        "IT budget optimization",
        "cybersecurity cost savings"
      ]}
      canonicalUrl="/landing-page/managed-IT-cybersecurity-cfos"
      schemaType="service"
      schemaData={{
        serviceType: "Managed IT & Cybersecurity Services for CFOs",
        areaServed: "United States",
        offers: {
          description: "Cost-effective managed IT and cybersecurity services focused on maximizing existing technology investments"
        }
      }}
    >
      <CFOHeroSection />
      
      <CFOChallengeSection />
      
      <BenefitSection
        title="Maximize What You Already Own"
        subtitle="The edgefi Approach"
        description="We help CFOs take control of IT and cybersecurity spend by optimizing existing investments rather than adding new ones."
        benefits={edgefiApproachBenefits}
        background="light"
      />
      
      <BenefitSection
        title="Why It Matters for CFOs"
        description="Every $1 saved in IT is a $1 added back to EBITDA. Our approach delivers measurable financial impact."
        benefits={financialBenefits}
        background="gradient"
      />
      
      <SocialProofSection />
      
      <CtaSection
        title="Let's Cut Your IT Spend Without Cutting Corners"
        description="Schedule a 20-minute CFO Strategy Session to see how much you can save."
        ctaText="Book My CFO Session"
        background="purple"
        modalTitle="CFO Strategy Session"
        modalDescription="Tell us about your current IT and cybersecurity investments. We'll show you opportunities to reduce costs while strengthening security."
        additionalFields={{
          lead_source: "CFO Landing Page",
          lead_interest: "IT Cost Optimization",
          target_audience: "CFO"
        }}
      />
    </LandingPageTemplate>
  );
};

export default ManagedITCybersecurityCFOs;